export default __webpack_public_path__ + "static/media/very-good-icon.597667e8.svg";